<template>
  <div class="ma-4">
    <monthly-amount-dialog
      ref="mileage"
      :mileageData="selectedMileageItem"
      @getTransactions="getTransactions"
    />
    <v-snackbar v-model="msg" top>
      {{ text }}
      <v-btn color="pink" text @click="msg = false"> Close</v-btn></v-snackbar
    >
    <StaffNav />
    <v-row dense>
      <v-col cols="12" lg="3" xl="2">
        <StaffSide />
      </v-col>

      <v-col cols="12" lg="9" xl="10">
        <!-- <v-row dense>
          <v-col cols="12" sm="12"> -->
            <!-- <v-card elevation="0" outlined min-height="190">
              <v-card-title class="mx-2">Balance</v-card-title>
              <v-divider class="mx-2"></v-divider> -->

              <!-- <v-container>
                <v-row dense class="mt-3 mb-2 ">
                  <v-col cols="12" md="6">
                    <v-card
                      class="d-flex justify-space-between pa-2"
                      outlined
                      rounded="lg"
                      color="#8C000D"
                    >
                      <div d-flex class="pa-3 ml-2">
                        <div>
                          <h3 class="font-weight-medium white--text">
                            EBT
                          </h3>
                          <span class="balance-amount white--text"
                            >${{ dashboardData.ebt }}</span
                          >
                          <br />
                          <span class="white--text font-weight-thin caption">{{
                            dashboardData.Date
                          }}</span>
                        </div>
                      </div>
                      <div class="align-self-center mr-5">
                        <v-icon large color="white" style="font-size: 70px;">
                          mdi-credit-card-multiple
                        </v-icon>
                      </div>
                    </v-card>
                  </v-col>
                  <v-col cols="12" md="6">
                    <v-card
                      class="d-flex justify-space-between pa-2"
                      outlined
                      rounded="lg"
                      color="#0B3866"
                    >
                      <div d-flex class="pa-3 ml-2">
                        <div>
                          <h3 class="font-weight-medium white--text">
                            Credit Card
                          </h3>
                          <span class="balance-amount white--text"
                            >${{ dashboardData.creditCard }}</span
                          >
                          <br />
                          <span class="white--text font-weight-thin caption">{{
                            dashboardData.Date
                          }}</span>
                        </div>
                      </div>
                      <div class="align-self-center mr-5">
                        <v-icon large color="white" style="font-size: 70px;">
                          mdi-credit-card-multiple
                        </v-icon>
                      </div>
                    </v-card>
                  </v-col>
                  <v-col cols="12" md="6">
                    <v-card
                      class="d-flex justify-space-between pa-2"
                      outlined
                      rounded="lg"
                      color="#52A65E"
                    >
                      <div d-flex class="pa-3 ml-2">
                        <div>
                          <h3 class="font-weight-medium white--text">
                            Deposit
                          </h3>
                          <span class="balance-amount white--text"
                            >${{ dashboardData.deposit }}</span
                          >
                          <br />
                          <span class="white--text font-weight-thin caption">{{
                            dashboardData.Date
                          }}</span>
                        </div>
                      </div>
                      <div class="align-self-center mr-5">
                        <v-icon large color="white" style="font-size: 70px;">
                          mdi-credit-card-multiple
                        </v-icon>
                      </div>
                    </v-card>
                  </v-col>
                  <v-col cols="12" md="6">
                    <v-card
                      class="d-flex justify-space-between pa-2"
                      outlined
                      rounded="lg"
                      color="#1E81AC"
                    >
                      <div d-flex class="pa-3 ml-2">
                        <div>
                          <h3 class="font-weight-medium white--text">
                            Expenses
                          </h3>
                          <span class="balance-amount white--text"
                            >${{ dashboardData.expense }}</span
                          >
                          <br />
                          <span class="white--text font-weight-thin caption">{{
                            dashboardData.Date
                          }}</span>
                        </div>
                      </div>
                      <div class="align-self-center mr-5">
                        <v-icon large color="white" style="font-size: 70px;">
                          mdi-credit-card-multiple
                        </v-icon>
                      </div>
                    </v-card>
                  </v-col>
                </v-row>
              </v-container> -->

              <!-- <v-divider class="mx-2"></v-divider>
              <v-row align="center" justify="end" class="mx-2 my-2 ">
                <span class="mr-10">
                  Current Balance
                </span>
                <span
                  class="ml-10 mr-2 green--text font-weight-bold balance-amount--current"
                >
                  ${{ dashboardData.total }}
                </span>
              </v-row>
            </v-card> -->
          <!-- </v-col> -->

          <!-- <latest-transactions :latest-transactions="latestTransactions" /> -->
        <!-- </v-row> -->

        <v-row dense>
          <v-col cols="12" md="12">
            <v-card elevation="0" outlined>
              <v-data-table
                :headers="headers"
                :items="mileagess"
                :item-class="rowColor"
                class=" mt-4"
                sort-asc
                :loading="isLoading"
                loading-text="Loading Mileage Logs"
                :search="search"
                height="475"
              >
                <template v-slot:item.select="{ item }">
                  <router-link
                    :to="{
                      name: 'Mileage History',
                      params: { mileageID: item._id },
                    }"
                  >
                    <v-btn
                      x-small
                      class="white--text"
                      color="#2b3990"
                      @click="setCloseOut(item.CloseOut)"
                    >
                      select
                    </v-btn>
                  </router-link>
                </template>

                <template v-slot:item.CloseOut="{ item }">
                  <v-chip small :color="item.CloseOut ? 'red' : 'green'" dark>
                    {{ item.CloseOut ? "Close Out" : "Active" }}
                  </v-chip>
                </template>

                <template v-slot:top>
                  <v-toolbar flat color="white">
                    <v-toolbar-title>Monthly Mileage</v-toolbar-title>
                    <v-divider class="mx-4" inset vertical></v-divider>
                    <v-spacer></v-spacer>
                    <v-text-field
                      v-model="search"
                      clearable
                      flat
                      solo-inverted
                      hide-details
                      prepend-inner-icon="search"
                      label="search"
                      class="desktop"
                    ></v-text-field>
                    <v-spacer></v-spacer>

                    <!-- Mileage Dialog -->

                    <v-btn
                      color="#2b3990"
                      dark
                      class="mb-2 mt-2"
                      @click="showAdd()"
                    >
                      <v-icon left>add</v-icon>
                      Open New Month</v-btn
                    >
                  </v-toolbar>
                  <v-text-field
                    v-model="search"
                    clearable
                    flat
                    solo-inverted
                    hide-details
                    prepend-inner-icon="search"
                    label="search"
                    class="mobile ml-5 mr-5 mb-3 mt-3"
                  ></v-text-field>
                </template>
                <!-- <template v-slot:item.ClientSignature="{ item }">
                  <v-img
                    max-height="80"
                    max-width="150"
                    :src="item.ClientSignature"
                  ></v-img>
                </template> -->
                <template v-slot:item.actions="{ item }">
                  <v-icon
                    small
                    class="mr-2"
                    @click="
                      viewMileage(item);
                      $event.stopPropagation();
                    "
                  >
                    mdi-eye
                  </v-icon>
                  <!-- <v-icon small class="mr-2" @click="editFinance(item)">
          mdi-pencil
        </v-icon> -->
                  <v-icon
                    small
                    @click="
                      deleteMileage(item);
                      $event.stopPropagation();
                    "
                  >
                    mdi-delete
                  </v-icon>
                  <!-- <v-icon small @click="addDeal(item)">
          add
        </v-icon> -->
                </template>
                <template v-slot:no-data>
                  <v-btn
                    color="#2b3990"
                    class="white--text"
                    @click="getMileages()"
                    >Reset</v-btn
                  >
                </template>
              </v-data-table>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <Foot />
  </div>
</template>

<script>
import axios from "axios";
import StaffNav from "@/components/StaffNav";
import StaffSide from "@/components/StaffSide";
import Foot from "@/components/Footer";
import MonthlyAmountDialog from "@/components/mileage/MonthlyAmountDialog";
// import LatestTransactions from "@/components/mileage/LatestTransactions";
import { mapMutations, mapState, mapGetters, mapActions } from "vuex";

import moment from "moment";

const url = require("../client_config/config").url;

export default {
  components: {
    StaffNav,
    StaffSide,
    MonthlyAmountDialog,
    // LatestTransactions,
    Foot,
  },
  data: function() {
    return {
      headers: [
        {
          text: "Select",
          align: "start",
          sortable: false,
          value: "select",
        },
        { text: "Date", value: "Date" },
        { text: "Month", value: "Month" },
        { text: "($)Balance", value: "Amount" },
        { text: "Staff Signature", value: "StaffSignature", width: "200px" },
        { text: "Status", value: "CloseOut" },
        { text: "Actions", value: "actions", sortable: false },
      ],
      staff: "",
      signed: false,
      dialog: false,
      transactionDialog: false,
      editMileage: false,
      newMileage: false,
      msg: false,
      search: "",
      text: "",
      mileages: [],
      filteredMileages: [],
      staffID: this.$route.params.employeeID,
      userID: "",
      tempData: [],
      titleForm: "New Mileage Month",
      mileageID: "",
      newDate: "",
      newAction: "",
      newTransactionMethods: "",
      newAmount: "",
      newPayee: "",
      newExpenseCategory: "",
      newPurchaseLocation: "",
      newDepositCategory: "",
      newNotes: "",
      newSignature: "",
      newClientSignature: "",
      signaturepop2: false,
      newBalance: 0,
      newSigned: "",
      newReceipt: "",
      newReceiptImage: "",
      editedIndex: -1,
      uploadImg: "",
      selectedTransactionMethod: [],
      editedItem: {
        date: "",
        action: "",
        transactionMethods: "",
        amount: "",
        payee: "",
        expenseCategory: "",
        purchaseLocation: "",
        depositCategory: "",
        notes: "",
        signature: "",
        clientSignature: "",
        signed: "",
        balance: "",
      },
      defaultItem: {
        date: "",
        action: "",
        transactionMethods: "",
        amount: "",
        payee: "",
        expenseCategory: "",
        purchaseLocation: "",
        depositCategory: "",
        notes: "",
        signature: "",
        clientSignature: "",
        signed: "",
        balance: "",
      },
      selectedMileageItem: "",
      deposit: 0,
      expense: 0,
      EBT: 0,
      creditCard: 0,
      total: 0,
      mileagesData: [],
      AllMileagesData: [],
    };
  },

  mounted() {
    this.getMileages(this.staffID);
    this.getTransactions();
    this.getAllMileageTransactions();
  },

  computed: {
    ...mapState({
      mileagess: (state) => state.mileages.mileages,
      latestTransactions: (state) => state.mileages.latestTransactions,
      allMileageTransactions: (state) => state.mileages.allMileageTransactions,
    }),

    ...mapGetters([
      "isLoading",
      "getMileageData",
      "getAllMileageTransactionData",
    ]),

    formTitle() {
      return this.editedIndex != 1 ? "New Item" : "Edit Item";
    },

    dashboard() {
      const { mileagess, allMileageTransactions } = this;
      return {
        mileagess,
        allMileageTransactions,
      };
    },

    dashboardData() {
      try {
        let deposit = 0;
        let expense = 0;
        let ebt = 0;
        let creditCard = 0;

        let latestTransaction = this.mileagesData
          .map(function(e) {
            return e;
          })
          .sort()
          .reverse()[0];

        this.AllMileagesData.filter((item) => {
          if (item.MileageID === latestTransaction._id) {
            if (item.TransactionType == "Expense") {
              expense += parseInt(item.Amount);
            }
            if (item.TransactionType == "Deposit") {
              deposit += parseInt(item.Amount);
            }
            if (item.TransactionMethods == "EBT") {
              ebt += parseInt(item.Amount);
            }
            if (item.TransactionMethods == "Credit Card") {
              creditCard += parseInt(item.Amount);
            }
          }
        });

        return {
          total: deposit - expense,
          Date: latestTransaction.Date,
          expense: expense,
          deposit: deposit,
          ebt: ebt,
          creditCard: creditCard,
        };
      } catch (error) {
        return error;
      }
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
    dashboard: {
      handler(val) {
        this.mileagesData = val.mileagess;
        this.AllMileagesData = val.allMileageTransactions;
      },
      deep: true,
    },
  },

  created() {
    this.userID = localStorage.getItem("userID");
  },

  methods: {
    ...mapActions([
      "getMileages",
      "getLatestTransactions",
      "getAllMileageTransactions",
    ]),

    ...mapMutations({
      setMonthlyAmountDialog: "SET_MONTHLY_AMOUNT_DIALOG",
      setCloseOut: "SET_MILEAGE_CLOSEOUT",
    }),
    initialize() {
      this.mileages = [];
    },
    viewMileage(item) {
      console.log(item);
      this.$refs.mileage.onViewItem(item);
      this.setMonthlyAmountDialog(true);
    },
    showAdd() {
      this.setMonthlyAmountDialog(true);
    },

    clear() {
      this.newDate = "";
      this.newAction = "";
      this.newTransactionMethods = "";
      this.newAmount = "";
      this.newPayee = "";
      this.newExpenseCategory = "";
      this.newPurchaseLocation = "";
      this.newDepositCategory = "";
      this.newNotes = "";
      this.newSignature = "";
      this.newClientSignature = "";
      this.newBalance =
        this.mileages.length < 1
          ? 0
          : parseInt(this.mileages[this.mileages.length - 1].Balance);
      this.newReceipt = "";
      this.newSigned = "";
      this.newReceiptImage = "";
    },

    async deleteMileage(item) {
      let confirmDeletion = confirm(
        "Are you sure you want to delete this mileage?"
      );
      if (confirmDeletion) {
        try {
          const response = await this.$store.dispatch("deleteMileage", item._id);
          if (response.success) {
            await this.$store.commit("DELETE_LATEST_TRANSACTION", item._id);
            await this.getTransactions();
          }
        } catch (error) {
          console.log(error);
        }
      }
    },

    close() {
      this.dialog = false;
      this.clear();
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    rowColor(item) {
      if (item.TransactionMethods === "Cash") {
        return "green lighten-5";
      }

      if (item.TransactionMethods === "Debit Card") {
        return "blue lighten-5";
      }

      if (item.TransactionMethods === "EBT") {
        return "red lighten-5";
      }
    },

    getUsers: function() {
      axios.get(`${url}/users`).then(async (res) => {
        this.users = res.data.users;
        for (var i = 0; i < this.users.length; i++) {
          if (this.userID == this.users[i]._id) {
            this.staff = this.users[i].Name;
          }
        }
      });
    },

    transactionFilterSelect() {
      this.transactionDialog = false;

      const mileages = [];
      this.mileages = [];
      axios
        .get(`${url}/mileages/transaction`, {
          params: {
            transactionMethod: this.selectedTransactionMethod,
          },
        })
        .then((res) => {
          console.log(res.data.transactions);
          res.data.transactions.forEach((item) => {
            var dt = new Date(item.Date);

            mileages.push({
              Action: item.Action,
              Amount: item.Amount,
              Balance: item.Balance,
              StaffID: item.StaffID,
              Date: moment(dt).format("MM-DD-YYYY"),
              DepositCategory: item.DepositCategory,
              ExpenseCategory: item.ExpenseCategory,
              Notes: item.Notes,
              Payee: item.Payee,
              PurchaseLocation: item.PurchaseLocation,
              Receipt: item.Receipt,
              Signature: item.Signature,
              TransactionMethods: item.TransactionMethods,
            });
          });
        })
        .catch((err) => {
          this.msg = true;
          this.text = err.response.data.msg;
        })
        .finally(() => {
          if (this.selectedTransactionMethod.length === 0) {
            this.mileages = this.filteredMileages;
          } else {
            this.mileages = mileages;
          }
          this.transactionDialog = false;
        });
    },

    async getTransactions() {
      await this.getLatestTransactions(this.staffID);
    },
  },
};
</script>
<style>
.Red {
  background-color: #ffebee;
}

.Green {
  background-color: #e8f5e9;
}
@media only screen and (min-width: 768px) {
  .mobile {
    display: none;
  }
}

@media only screen and (max-width: 600px) {
  .desktop {
    display: none;
  }
}

.balance-amount {
  font-size: 40px;
}

.balance-amount--current {
  font-size: 20px;
}
</style>
